var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgRocket = function SvgRocket(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10,
    fill: "none",
    viewBox: "0 0 14 10",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.355 5.706H.703a.68.68 0 0 1-.501-.202.68.68 0 0 1-.202-.5q0-.3.202-.502A.68.68 0 0 1 .703 4.3h10.652L8.268 1.214a.66.66 0 0 1-.206-.49.72.72 0 0 1 .206-.499A.72.72 0 0 1 8.77 0a.66.66 0 0 1 .501.211l4.2 4.199a.78.78 0 0 1 .24.593.775.775 0 0 1-.24.593l-4.2 4.2a.67.67 0 0 1-.496.206.7.7 0 0 1-.506-.221.74.74 0 0 1-.21-.494.66.66 0 0 1 .21-.494z"
  })));
};
export default SvgRocket;